import HighlightOff from '@material-ui/icons/HighlightOff'

export const Nope = HighlightOff

export default Nope